// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Mapeo de Colores DoControl a Variables PrimeReact/Globales */

  /* DoControl Colors */
  --docontrol-primary: #007bff;
  --docontrol-secondary: #6c757d;
  --docontrol-success: #28a745;
  --docontrol-danger: #dc3545;
  --docontrol-warning: #ffc107;
  --docontrol-info: #17a2b8;
  --docontrol-light: #f8f9fa;
  --docontrol-dark: #343a40;
  --docontrol-white: #ffffff;
  --docontrol-black: #000000;

  /* PrimeReact Overrides */
  --primary-color: var(--docontrol-primary);
  --primary-color-text: #ffffff;

  /* Surface Colors (Fondos y Bordes) */
  --surface-ground: var(--docontrol-light);
  --surface-section: #ffffff;
  --surface-card: #ffffff;
  --surface-border: #dfe7ef;
  --surface-overlay: #ffffff;

  /* Text Colors */
  --text-color: var(--docontrol-dark);
  --text-color-secondary: var(--docontrol-secondary);

  /* Status Colors */
  --green-500: var(--docontrol-success);
  --red-500: var(--docontrol-danger);
  --yellow-500: var(--docontrol-warning);
  --blue-500: var(--docontrol-info);

  /* General Styles */
  --font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

/* Sobrescribir estilos específicos de componentes PrimeReact para que coincidan con Bootstrap/DoControl */

/* Botones */
.p-button {
  border-radius: 4px; /* Bootstrap style */
}

.p-button.p-button-danger {
  background-color: var(--docontrol-danger);
  border-color: var(--docontrol-danger);
}

.p-button.p-button-success {
  background-color: var(--docontrol-success);
  border-color: var(--docontrol-success);
}

.p-button.p-button-warning {
  background-color: var(--docontrol-warning);
  border-color: var(--docontrol-warning);
  color: var(--docontrol-dark);
}

.p-button.p-button-secondary {
  background-color: var(--docontrol-secondary);
  border-color: var(--docontrol-secondary);
}

/* Inputs */
.p-inputtext {
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
}

.p-inputtext:enabled:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  border-color: #80bdff;
}

/* Cards / Paneles */
.p-card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

/* Tablas / DataTables */
/* Replicando estilo DoControl: Fondo Azul Claro, Texto Azul Oscuro, Borde Fuerte */
.p-datatable .p-datatable-thead > tr > th {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
  border-color: #e3f2fd !important;
  border-bottom: 2px solid #2196f3 !important;
  font-weight: bold;
}

/* Color de iconos de ordenamiento en header */
.p-datatable
  .p-datatable-thead
  > tr
  > th
  .p-column-header-content
  .p-sortable-column-icon {
  color: #1976d2 !important;
}

/* Estado hover y highlight de header */
.p-datatable .p-datatable-thead > tr > th:hover,
.p-datatable .p-datatable-thead > tr > th.p-highlight {
  background-color: #bbdefb !important; /* Un poco más oscuro al hover */
  color: #0d47a1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/docontrol-theme.css"],"names":[],"mappings":"AAAA;EACE,+DAA+D;;EAE/D,qBAAqB;EACrB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;;EAE1B,yBAAyB;EACzB,yCAAyC;EACzC,6BAA6B;;EAE7B,qCAAqC;EACrC,wCAAwC;EACxC,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;;EAE1B,gBAAgB;EAChB,mCAAmC;EACnC,kDAAkD;;EAElD,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,sCAAsC;EACtC,iCAAiC;;EAEjC,mBAAmB;EACnB;;wEAEsE;AACxE;;AAEA,0GAA0G;;AAE1G,YAAY;AACZ;EACE,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,mDAAmD;EACnD,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB,mFAAmF;AACnF;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;;;;;;EAME,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;;EAEE,oCAAoC,EAAE,gCAAgC;EACtE,yBAAyB;AAC3B","sourcesContent":[":root {\n  /* Mapeo de Colores DoControl a Variables PrimeReact/Globales */\n\n  /* DoControl Colors */\n  --docontrol-primary: #007bff;\n  --docontrol-secondary: #6c757d;\n  --docontrol-success: #28a745;\n  --docontrol-danger: #dc3545;\n  --docontrol-warning: #ffc107;\n  --docontrol-info: #17a2b8;\n  --docontrol-light: #f8f9fa;\n  --docontrol-dark: #343a40;\n  --docontrol-white: #ffffff;\n  --docontrol-black: #000000;\n\n  /* PrimeReact Overrides */\n  --primary-color: var(--docontrol-primary);\n  --primary-color-text: #ffffff;\n\n  /* Surface Colors (Fondos y Bordes) */\n  --surface-ground: var(--docontrol-light);\n  --surface-section: #ffffff;\n  --surface-card: #ffffff;\n  --surface-border: #dfe7ef;\n  --surface-overlay: #ffffff;\n\n  /* Text Colors */\n  --text-color: var(--docontrol-dark);\n  --text-color-secondary: var(--docontrol-secondary);\n\n  /* Status Colors */\n  --green-500: var(--docontrol-success);\n  --red-500: var(--docontrol-danger);\n  --yellow-500: var(--docontrol-warning);\n  --blue-500: var(--docontrol-info);\n\n  /* General Styles */\n  --font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial,\n    sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n\n/* Sobrescribir estilos específicos de componentes PrimeReact para que coincidan con Bootstrap/DoControl */\n\n/* Botones */\n.p-button {\n  border-radius: 4px; /* Bootstrap style */\n}\n\n.p-button.p-button-danger {\n  background-color: var(--docontrol-danger);\n  border-color: var(--docontrol-danger);\n}\n\n.p-button.p-button-success {\n  background-color: var(--docontrol-success);\n  border-color: var(--docontrol-success);\n}\n\n.p-button.p-button-warning {\n  background-color: var(--docontrol-warning);\n  border-color: var(--docontrol-warning);\n  color: var(--docontrol-dark);\n}\n\n.p-button.p-button-secondary {\n  background-color: var(--docontrol-secondary);\n  border-color: var(--docontrol-secondary);\n}\n\n/* Inputs */\n.p-inputtext {\n  border-radius: 4px;\n  padding: 0.375rem 0.75rem;\n}\n\n.p-inputtext:enabled:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  border-color: #80bdff;\n}\n\n/* Cards / Paneles */\n.p-card {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem;\n}\n\n/* Tablas / DataTables */\n/* Replicando estilo DoControl: Fondo Azul Claro, Texto Azul Oscuro, Borde Fuerte */\n.p-datatable .p-datatable-thead > tr > th {\n  background-color: #e3f2fd !important;\n  color: #1976d2 !important;\n  border-color: #e3f2fd !important;\n  border-bottom: 2px solid #2196f3 !important;\n  font-weight: bold;\n}\n\n/* Color de iconos de ordenamiento en header */\n.p-datatable\n  .p-datatable-thead\n  > tr\n  > th\n  .p-column-header-content\n  .p-sortable-column-icon {\n  color: #1976d2 !important;\n}\n\n/* Estado hover y highlight de header */\n.p-datatable .p-datatable-thead > tr > th:hover,\n.p-datatable .p-datatable-thead > tr > th.p-highlight {\n  background-color: #bbdefb !important; /* Un poco más oscuro al hover */\n  color: #0d47a1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
